import {
  EmbeddedCheckout,
  EmbeddedCheckoutProvider,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { STRIPE_PUB_KEY, devURL } from "../../../utils";
import DashboardLayout from "../../../components/ui/DashboardLayout";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../../../components/ui/Loading";
import { toast } from "react-toastify";
import { BackButton } from "../../../components/ui/Swicons";

const stripePromise = loadStripe(STRIPE_PUB_KEY);

const StripeCheckoutForm = () => {
  const [clientSecret, setClientSecret] = useState("");
  const [loading, setLoading] = useState(true);
  const { transfer_id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Create a Checkout Session as soon as the page loads

    const token = localStorage.getItem("swToken");
    axios
      .post(
        `${devURL}/payments/stripe-create-checkout`,
        {
          transfer_id,
        },
        {
          headers: { token: token },
        }
      )
      .then((data) => {
        setClientSecret(data.data.clientSecret);
      })
      .catch((error) => {
        console.log(error);
        if (error.response?.data) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Something went wrong");
        }
        navigate(`/transaction-details/${transfer_id}`);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [transfer_id]);

  return (
    <DashboardLayout>
      <button onClick={() => navigate(-1)} className="hidden lg:block">
        <BackButton />
      </button>
      {loading ? <Loading /> : null}
      <div id="checkout">
        {clientSecret && (
          <EmbeddedCheckoutProvider
            stripe={stripePromise}
            options={{ clientSecret }}
          >
            <EmbeddedCheckout />
          </EmbeddedCheckoutProvider>
        )}
      </div>
    </DashboardLayout>
  );
};

export default StripeCheckoutForm;
